<template>
  <div class="relative lg:mx-12 md:mx-12 mx-4">
    <img
      src="@/assets/images/line/Frame 1000002302.png"
      alt="lineimg"
      class="m-auto"
    />
    <PopupWhoWeAre
      :isActive="isDetailsActive"
      :selectedWhoWeAre="selectedWhoWeAre"
      @close="toggleDetails"
    />
    <div class="absolute bg-design6 mob-hidden">
      <img
        src="../../../assets/images/bg-des/bgd6.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design7">
      <img
        src="../../../assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="lg:pt-0 md:pt-0 w-full mx-auto z-10">
      <p class="title md:font-normal lg:font-normal font-bold sm-fsize16">
        Who need us
      </p>
      <div class="lg:mt-2 md:mt-2 mt-6 bg-white">
        <div
          class="lg:grid md:grid lg:grid-cols-2 md:grid-cols-2 lg:grid-rows-2 md:grid-rows-2 lg:gap-8 md:gap-8"
        >
          <div
            class="card1bg md:p-8 relative lg:p-8 p-4 rounded-xl lg:mb-0 md:mb-0 mb-4 cursor-pointer"
            @click="toggleDetails(true, item)"
            v-for="(item, index) in cards"
            :key="index"
          >
            <div class="flex gap-2 items-center">
              <div class="w-1/2">
                <p
                  class="lg:text-xl md:text-xl sm-fsize14 text-black font-semibold pb-2 cursor-pointer"
                  @click.stop="handleClick(item.route)"
                >
                  {{ item.title }}
                </p>
                <p
                  class="fsize18 sm-fsize14 pt-1 font-normal lh32px sm-lineh21 ellipsis-4 cursor-pointer"
                >
                  {{ item.description }}
                </p>
                <!-- <p
                  class="
                    hover:underline
                    text-primary
                    lg:text-lg
                    md:text-lg
                    sm-fsize14
                    underline
                    pt-3
                    text-primary
                    cursor-pointer
                  "
                  @click="handleClick(item.route)"
                >
                  {{ item.button }}
                </p> -->
              </div>
              <div class="w-1/2 px-0 my-auto">
                <img :src="item.img" alt="" class="object-contain" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PopupWhoWeAre from "./PopupWhoWeAre.vue";
export default {
  components: {
    PopupWhoWeAre,
  },
  data() {
    return {
      selectedWhoWeAre: {},
      isDetailsActive: false,
      cards: [
        {
          id: "01",
          title: "Caregiver",
          description:
            "In today’s urban living, long-term caregiving can be overwhelming and stressful. Our holistic services provide education, tools, emotional support, and handholding to caregivers. This helps them as they navigate challenges while also ensuring their own well-being. ",
          button: " Read more",
          img: require("@/assets/images/Caregiver-(1)home.jpg"),
          // img: "https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/Caregiver.webp",
          route: "caregiver",
        },
        {
          id: "02",
          title: "    Well-wisher",
          description:
            "We all know and worry about caregivers among our friends and family and want to be of help. Sometimes we don’t know how, when, or in what way to approach or support them. We help you provide empathetic support and equip yourself to be an effective caregiver companion.",
          button: " Read more",
          img: require("@/assets/images/Copy-of-Wellwishers-(1)home.jpg"),
          // img: "https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/Wellwishers.webp",
          route: "wellwisher",
        },
        {
          id: "03",
          title: "Healthcare Professional",
          description:
            "Healthcare professionals can suffer from burnout and compassion fatigue as they navigate managing care for patients and their families. We partner with healthcare institutions to empower professionals to provide efficient and contemporary approaches to human-touch-led care.",
          button: " Read more",
          img: "https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/HCP.webp",
          route: "hcp",
        },
        {
          id: "04",
          title: "Corporate",
          description:
            "Achieving the benefits of being future-ready while building diversity of experiences and inclusion entails ensuring a caregiver-friendly workplace. We support progressive organisations through advisory service, training programmes, and other services.",
          button: " Read more",
          img: require("@/assets/images/Home-Pahe--Corporate.jpg"),
          // img: "https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/Corporate.webp",
          route: "corporate",
        },
      ],
    };
  },
  methods: {
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedWhoWeAre = item;
    },
    handleClick(name) {
      this.$router.push({ name: name });
      this.toggleNavbar();
    },
  },
};
</script>
